import React from 'react';
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';
import HeroSection from './sections/HeroSection';
import ProblemSolutionSection from './sections/ProblemSolutionSection';
import ProductShowcaseSection from './sections/ProductShowcaseSection';
import TestimonialSection from './sections/TestimonialSection';
import SecuritySection from './sections/SecuritySection';
import StrategySection from './sections/StrategySection';
import DischargeCopilotSection from './sections/DischargeCopilotSection';
import InvestorVisionSection from './sections/InvestorVisionSection';
import NewsSection from './sections/NewsSection';
import TeamStripSection from './sections/TeamStripSection';
import PartnerStripSection from './sections/PartnerStripSection';
import CtaSection from './sections/CtaSection';
import useScrollReveal from '../lib/useScrollReveal';

export default function LandingPage() {
  useScrollReveal();

  // Sections mount after the browser's native anchor pass, so a fresh load of
  // /#team (e.g. from the footer of /press) lands at the top without this.
  React.useEffect(() => {
    const id = window.location.hash.slice(1);
    // 'instant' opts out of the global CSS smooth-scroll for the initial jump.
    if (id) document.getElementById(id)?.scrollIntoView({ behavior: 'instant' as ScrollBehavior });
  }, []);

  return (
    <div className="min-h-screen bg-kc-bg text-kc-ink">
      <Navbar />
      <HeroSection />
      <ProblemSolutionSection />
      <ProductShowcaseSection />
      <TestimonialSection />
      <SecuritySection />
      <StrategySection />
      <DischargeCopilotSection />
      <InvestorVisionSection />
      <NewsSection />
      <TeamStripSection />
      <PartnerStripSection />
      <CtaSection />
      <Footer />
    </div>
  );
}
